import { apiFetch } from "../../../shared/api/client";
import type {
  ChangeStatusAcknowledgement,
  OrderDetails,
  OrderEventsResponse,
  OrderListResponse,
  OrderSnapshotResponse,
} from "../../../shared/api/types";
import type { OrderFilters } from "../../../data/query-keys/orders";

export async function fetchOrders(
  filters: OrderFilters,
  cursor?: string,
): Promise<OrderListResponse> {
  const params = new URLSearchParams({
    limit: "50",
    status: filters.status,
    date: filters.date,
  });
  if (filters.search) params.set("search", filters.search);
  if (cursor) params.set("cursor", cursor);
  return apiFetch<OrderListResponse>(`/api/v2/orders?${params.toString()}`);
}

export async function fetchOrdersSnapshot(
  filters: OrderFilters,
  cursor?: string,
): Promise<OrderSnapshotResponse> {
  const params = new URLSearchParams({
    limit: "100",
    status: filters.status,
    date: filters.date,
  });
  if (filters.search) params.set("search", filters.search);
  if (cursor) params.set("cursor", cursor);
  return apiFetch<OrderSnapshotResponse>(
    `/api/v2/orders/snapshot?${params.toString()}`,
  );
}

export async function fetchOrderEvents(after: number): Promise<OrderEventsResponse> {
  return apiFetch<OrderEventsResponse>(`/api/v2/orders/events?after=${after}`);
}

export async function fetchOrderDetails(orderId: number): Promise<OrderDetails> {
  return apiFetch<OrderDetails>(`/api/v2/orders/${orderId}`);
}

export async function sendStatusCommand(
  orderId: number,
  newStatus: string,
  expectedVersion: number,
  clientMutationId: string,
  clientId: string,
): Promise<ChangeStatusAcknowledgement> {
  return apiFetch<ChangeStatusAcknowledgement>(
    `/api/v2/orders/${orderId}/change-status`,
    {
      method: "POST",
      headers: {
        "X-Client-Mutation-Id": clientMutationId,
        "X-Client-Id": clientId,
      },
      body: JSON.stringify({ newStatus, expectedVersion }),
    },
  );
}
